// Sidebar.js
import React, { useState, useEffect, forwardRef } from 'react';
import './Sidebar.css';
import {MenuList} from './Menu';
import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from "../../Authentication Services/AuthService";
import { IoLogOut } from "react-icons/io5";
import { useTranslation } from 'react-i18next';

const Sidebar = forwardRef(({ isOpen, menuState, loggingOut }, ref) => {
  const { t } = useTranslation('sidebar');
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState('Dashboard');

  useEffect(() => {
    setActiveItem(MenuList.find(x =>"/"+x.to === location.pathname).title)
  }, [location.pathname]);

  const menuClick = async (option) => {
    console.log(option)
    setActiveItem(option.title)

    try {
      const res = await axios.get(process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Authenticated, {
        withCredentials: true
      })
      if (res.status === 200){
          navigate("/"+option.to)
          
      }
      menuState(false)
  }
  catch(e) {
      navigate(0)
  }
    
  }

function logoutClicked()
{
  loggingOut(true)
  logout()
        .then(() => {
            navigate(0);
        })
        .catch((error) => {		
          navigate("/")
        }).finally((f) => {
            loggingOut(false)
        })
}

  return (
    <div ref={ref} className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
      
      <div className="sidebar-content">
        {MenuList.map((item, index) => (
          <div
            key={index}
            className={`sidebar-item ${activeItem === item.title ? 'active' : ''}`}
            onClick={() => menuClick(item)}
            title={!isOpen ? item.title : ''}
          >
            <span className="icon">{item.iconStyle}</span>
            {isOpen && <span className="menu-label">{t(item.title)}</span>}
          </div>
        ))}
          <div
            style={{position:"absolute", bottom:0, borderTop:"1px solid #cbcbcb91", width:"220px"}}
            className={`sidebar-item ${activeItem === "Logout" ? 'active' : ''}`}
            onClick={() => logoutClicked()}
            title={!isOpen ? "Logout" : ''}
          >
            
            <span className="icon"><IoLogOut /></span>
            {isOpen && <span className="menu-label">{t('sidebar.menu.logout')}</span>}
          </div>
      </div>
    </div>
  );
});

export default Sidebar;
